const DEFAULT_TEXT = 'Cenojad.pl - porównywarka cen i ofert';

export function getLogoTitle(pageUrl?: string): string {
    return pageUrl === '/' ? DEFAULT_TEXT : 'Przejdź na stronę główną Cenojad.pl';
}

export function getLogoAlt(pageUrl?: string): string {
    return pageUrl === '/' ? DEFAULT_TEXT : 'cenojad';
}
